import React from 'react';
import PropTypes from 'prop-types';

import deleteIcon from '../../assets/icons/Icon-Delete-Gray.svg';
import './TableIconsCell.scss';

const TableIconsCell = ({ onDeleteClick })=> {
  return (
    <div className="table-icons-cell" data-testid="table-icons-cell">
      <button onClick={onDeleteClick} data-testid="delete-button">
        <img className="table-icons-cell__icon" src={deleteIcon} alt=""/>
      </button>
    </div>
  )
};

TableIconsCell.propTypes = {
  iconsColor: PropTypes.string, 
  onDeleteClick: PropTypes.func, 
  onStatsClick: PropTypes.func, 
  onMassageClick: PropTypes.func
};

TableIconsCell.defaultProps = {
  iconsColor: "", 
  onDeleteClick: ()=> {}, 
  onStatsClick: ()=> {}, 
  onMassageClick: ()=> {}
};

export default TableIconsCell;